<template>
    <div>
        <app-header :closeable="true" :title="'Not registered'"></app-header>

        <section class="container">
            <div class="intro-content pt--40 pb--40">
                <img src="/img/logo-title.png" alt="" class="intro-content__logo"/>
            </div>

            <div class="mb--lg">
                <div class="text--center text--lg weight--bold mb--10">
                    You don't have registration to this tournament.
                </div>

                <button-link :to="'/tournaments'" class="btn btn--block btn--white btn--left-icon mb--md">
                    <img src="/img/icons/find.svg" alt=""/>Go to tournaments list
                </button-link>
            </div>
        </section>
    </div>
</template>

<script>
import AppHeader from "../../../partial/AppHeader";
import ButtonLink from "../../../partial/ButtonLink";

export default {
    components: {AppHeader, ButtonLink}
}
</script>